/* Posity — laadstaat op de koopknop van de productpagina.

   Wat het doet: bij een klik op "In winkelwagen" gaat de knop op slot en komt er
   een spinner in de plaats van de tekst. Zodra de winkelwagenlade opengaat staat
   de knop weer normaal. Gaat het mis, dan komt de knop terug en verschijnt er een
   korte melding onder de knop.

   WAAROM DIT BESTAND EN NIET assets/product-form.js:
   dat is een kernbestand van Horizon en moet update-veilig blijven. Horizon zendt
   alles uit wat we nodig hebben — 'cart:update' bij succes, 'cart:error' bij een
   afwijzing van de server, beide bubbelend vanaf <product-form-component>. We
   luisteren dus mee in plaats van de component te herschrijven.

   DRIE VALKUILEN DIE DE VORM VAN DIT BESTAND BEPALEN:

   1. Niet synchroon disablen. Horizons #processAddToCart controleert zelf of er al
      een knop op disabled staat en STOPT dan zonder toe te voegen. Zetten we de knop
      in dezelfde tik als het submit-event op slot, dan blokkeren we onze eigen
      toevoeging. Vandaar queueMicrotask(): die draait ná Horizons synchrone code
      (tot en met de fetch-aanroep) maar nog vóór de browser iets tekent — voor het
      oog dus nog steeds "direct".

   2. De tekst niet uit de DOM halen. De variant-JS in posity-pdp.liquid schrijft
      addBtn.textContent bij elke variantwissel. Vervingen we de inhoud door een
      spinner-element, dan wist een wissel tijdens het laden dat weer. Daarom is de
      spinner een ::after in CSS en wordt het label alleen doorzichtig gezet.

   3. De disabled-property is niet de echte slotgrendel. Diezelfde variant-JS zet
      addBtn.disabled = !v.available en kan de knop dus midden in een verzoek weer
      openzetten. Het blokkeren van dubbele submits hangt daarom aan de inFlight-vlag
      hieronder, die het submit-event in de capture-fase afvangt.

   Netwerkfout: Horizon vangt die in een .catch() die alleen naar de console logt en
   geen event uitzendt. Zonder vangnet zou de knop dan voorgoed op de spinner blijven
   staan. Vandaar de time-out. */
(function () {
  'use strict';

  var LOADING_CLASS = 'is-atc-loading';
  /* Ruim boven een normale add-to-cart (~200-600ms), maar kort genoeg dat een
     klant niet naar een dode knop zit te kijken als het netwerk wegvalt. */
  var SAFETY_TIMEOUT = 12000;
  var GENERIC_ERROR = 'Toevoegen is niet gelukt. Probeer het opnieuw.';

  var mainBtn = document.getElementById('posity-pdp-add');
  if (!mainBtn) return;

  var formEl = mainBtn.closest('form');
  var productForm = mainBtn.closest('product-form-component');
  var errorEl = document.getElementById('posity-pdp-add-error');
  /* De stickybalk-knop staat buiten het formulier en klikt de hoofdknop aan. Hij moet
     mee op slot, anders is hij een tweede weg naar dezelfde dubbele submit. */
  var stickyBtn = document.getElementById('posity-stickybar-add');
  if (!formEl || !productForm) return;

  var buttons = [mainBtn, stickyBtn].filter(Boolean);
  var inFlight = false;
  var timer = null;
  /* Onthoud per knop of hij al op slot stond (uitverkochte variant); die mag na
     afloop niet per ongeluk actief worden. */
  var wasDisabled = new WeakMap();

  function applyLoading() {
    buttons.forEach(function (btn) {
      wasDisabled.set(btn, btn.disabled);
      btn.classList.add(LOADING_CLASS);
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    });
  }

  function reset(message) {
    inFlight = false;
    if (timer) { clearTimeout(timer); timer = null; }
    buttons.forEach(function (btn) {
      btn.classList.remove(LOADING_CLASS);
      btn.removeAttribute('aria-busy');
      btn.disabled = wasDisabled.get(btn) === true;
    });
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
  }

  formEl.addEventListener('submit', function (event) {
    if (inFlight) {
      /* Tweede submit terwijl de eerste loopt: hier stopt hij. stopImmediatePropagation
         houdt ook Horizons eigen listener op <product-form-component> tegen. */
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    inFlight = true;
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    /* Zie valkuil 1 in de kop: pas ná Horizons synchrone controle. */
    queueMicrotask(applyLoading);
    timer = setTimeout(function () {
      if (inFlight) reset(GENERIC_ERROR);
    }, SAFETY_TIMEOUT);
  }, true);

  productForm.addEventListener('cart:update', function (event) {
    if (!inFlight) return;
    /* Horizon stuurt ná een afwijzing óók een cart:update, met didError. De melding
       is dan al gezet door de cart:error hieronder — niet overschrijven. */
    if (event.detail && event.detail.data && event.detail.data.didError) return;
    reset();
  });

  productForm.addEventListener('cart:error', function (event) {
    if (!inFlight) return;
    var msg = event.detail && event.detail.data && event.detail.data.message;
    reset(msg || GENERIC_ERROR);
  });
})();
